// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../../Images/emp-logo-animation.svg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<section class=\"container flex flex-col items-center justify-center h-screen\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" class=\"w-128 h-128\"> <h1 class=\"my-20 text-lg font-semibold text-center uppercase font-display text-primary-500\">Coming soon.</h1> </section>";
// Exports
module.exports = code;